// Private Label: culoarea de fundal a valurilor se potrivește cu secțiunea de deasupra, chiar dacă secțiunile sunt reordonate.
(() => {
  const refresh = () => {
    let previous = '#ffffff';
    document.querySelectorAll('.fmi [data-fmi-tone]').forEach((s) => {
      if (s.hidden) return;
      const wave = s.querySelector(':scope > .section-wave');
      if (wave) {
        wave.style.backgroundColor = previous;
        wave.hidden = s.dataset.fmiTone === previous;
      }
      previous = s.dataset.fmiTone;
    });
  };
  if (!window.__fePlTone) {
    window.__fePlTone = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:reorder', refresh);
    document.addEventListener('shopify:section:unload', refresh);
  }
})();
